document.addEventListener('DOMContentLoaded', function() {
    const target = document.querySelector('#notifyPopup')
    const popup = document.querySelector('.tm-notify-popup')
    const notifyClose = document.querySelector('.tm_notify_close')
    const body = document.body;
    target.addEventListener('click', () => {
        // --- 遮罩层管理 ---
        // 创建遮罩层元素
        const overlay = document.createElement('div');
        overlay.className = 'tm_mark';
        body.appendChild(overlay); // 将遮罩层添加到 body 下
        popup.style.display = 'block'
        function closeNotify() {
            popup.style.display = 'none'
            overlay.remove();
        }
        notifyClose.addEventListener('click', closeNotify)
    })
});